/**
 * Floors the drag stops at, in px so it can clamp against pointer coordinates. These bound the
 * *gesture*, not the rendered column: the split is a ratio, so a window resize can still take a
 * column below its floor, and the columns are sized to follow. Do not restate either as a
 * `min-width` — a px floor cannot see the container, so it overflows it instead. See MainPanelRoot.
 */
export const PANEL_MIN_PX = 384; // 24rem
export const CHAT_MIN_PX = 448; // 28rem
